__turbopack_context__.v({
  "actionsWrapper": "index-module__MxFfiW__actionsWrapper",
  "container": "index-module__MxFfiW__container",
  "ghIconWrapper": "index-module__MxFfiW__ghIconWrapper",
  "main": "index-module__MxFfiW__main",
  "navInteractionIcon": "index-module__MxFfiW__navInteractionIcon",
  "navItems": "index-module__MxFfiW__navItems",
  "nodeIconAndMobileItemsToggler": "index-module__MxFfiW__nodeIconAndMobileItemsToggler",
  "nodeIconWrapper": "index-module__MxFfiW__nodeIconWrapper",
  "searchButtonSkeleton": "index-module__MxFfiW__searchButtonSkeleton",
  "sidebarItemToggler": "index-module__MxFfiW__sidebarItemToggler",
  "sidebarItemTogglerLabel": "index-module__MxFfiW__sidebarItemTogglerLabel",
});
